import {cardTitle} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const usersStyles = {
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  tableActions: {
    float: "right",
    marginTop: "-50px"
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  alertForm: {
    marginTop: "-20px",
    padding: "0 10px"
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  ...buttonStyle,
  ...customSelectStyle,
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  deleteSecretarioButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right"
  },
  deleteTutorButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right"
  },
};
export default usersStyles;
